import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=4c22f3bd&scoped=true"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDetailDialog.vue?vue&type=style&index=0&id=4c22f3bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22f3bd",
  null
  
)

export default component.exports